export const PENDING = "pending";
export const ACCEPTED = "accepted";
export const COMPLETE = "complete";
export const INCOMPLETE = "incomplete";

export const COMPLETE_LABEL = "Complete!";
